import { type GetActionsResponse } from '@bluebrick/discounts-service-module'
import { isEventCancellationError, encodeName, decodeName } from '@/common/utils'
import { useApi } from '@/features/api/useAPI'
import { useNotificationsStore } from '@/features/notifications/useNotificationsStore'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { type EventData } from '@/types'

export async function fetchActions(events: EventData[], abortSignal?: AbortSignal) {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiPost } = useApi()

	try {
		const { data } = await apiPost<GetActionsResponse>(
			`/events/actions/calculate`,
			// #event-names-vs-firewall
			{ events: events.map(encodeName) },
			{ signal: abortSignal, fetchOptions: { canRetry: true } }
		)

		return {
			// #event-names-vs-firewall
			unplannedEvents: data?.unplannedEvents?.map(decodeName),
			unscheduledEvents: data?.unscheduledEvents?.map(decodeName)
		}
	} catch (e) {
		if (isEventCancellationError(e, abortSignal)) {
			return
		}

		trackException(e, `Failed to load actions`)

		notifyError('Failed to load actions')
	}
}
